(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('header-drawer').forEach((drawer) => {
  drawer.addEventListener('click', (event) => {
    const link = event.target.closest('.menu-drawer__menu-item[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.href);
    if (!destination.hash || destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.search !== window.location.search) return;
    const details = drawer.querySelector(':scope > details');
    const summary = details && details.querySelector(':scope > summary');
    if (!details || !details.open || !summary || typeof drawer.closeMenuDrawer !== 'function') return;
    summary.setAttribute('aria-expanded', 'false');
    drawer.closeMenuDrawer(event, summary);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["liitt-auto-country"] && !Shopify.designMode) return;
  try {
    (function () {
  function initialize() {
    var form = document.getElementById('LiittAutomaticCountryForm');
    if (!form || (window.Shopify && window.Shopify.designMode) || form.dataset.liittCountryInitialized === 'true') return;
    form.dataset.liittCountryInitialized = 'true';
    document.addEventListener('submit', function (event) {
      if (event.defaultPrevented || !event.submitter || event.submitter.name !== 'checkout') return;
      var action = new URL(event.target.action, window.location.href);
      if (action.origin !== window.location.origin || !/\/cart\/?$/.test(action.pathname)) return;
      event.preventDefault();
      window.location.assign((form.dataset.routesRoot || '/') + 'checkout?checkout%5Bshipping_address%5D%5Bcountry%5D=' +
        encodeURIComponent(form.dataset.currentCountry));
    });
    var manualCountryKey = 'liitt-country-manual-v1';
    var manualLanguageKey = 'liitt-language-manual-v1';
    var redirectKey = 'liitt-country-redirect-v1';
    var stopped = false;
    var submitted = false;
    var controller = new AbortController();
    var timeout;
    function stop() {
      stopped = true;
      controller.abort();
      window.clearTimeout(timeout);
    }
    function remember(key, value) {
      stop();
      try { localStorage.setItem(key, value); } catch (error) {}
    }
    function languageInput(container) {
      return container.querySelector('input[name="language_code"], input[name="locale_code"], select[name="language_code"], select[name="locale_code"]');
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('localization-form a[data-value]');
      var manualForm = link && link.closest('localization-form');
      if (!manualForm) return;
      var country = manualForm.querySelector('input[name="country_code"], select[name="country_code"]');
      var language = languageInput(manualForm);
      if (language && (!country || link.hasAttribute('hreflang') || link.hasAttribute('lang'))) {
        remember(manualLanguageKey, link.dataset.value);
      } else if (country) {
        remember(manualCountryKey, link.dataset.value);
      }
    }, true);
    document.addEventListener('submit', function (event) {
      if (event.target === form) return;
      var country = event.target.querySelector('input[name="country_code"], select[name="country_code"]');
      var language = languageInput(event.target);
      if (country) remember(manualCountryKey, country.value);
      if (language) remember(manualLanguageKey, language.value);
      if (event.submitter && event.submitter.name === 'checkout') stop();
    }, true);
    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('localization-form')) return;
      if (event.target.name === 'country_code') remember(manualCountryKey, event.target.value);
      if (event.target.name === 'language_code' || event.target.name === 'locale_code') remember(manualLanguageKey, event.target.value);
    }, true);
    window.addEventListener('liitt:purchase-start', stop);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-liitt-direct-checkout], #CartDrawer-Checkout, [name="checkout"], .shopify-payment-button')) stop();
    }, true);
    var parameters = new URLSearchParams(window.location.search);
    if (parameters.has('country') || parameters.has('currency') || parameters.has('preview_theme_id')) return;
    var currentCountry = form.dataset.currentCountry;
    var currentLocale = (form.dataset.currentLocale || '').toLowerCase();
    var availableLocales = (form.dataset.availableLocales || '').toLowerCase().split(',').filter(Boolean);
    var manualCountry = false;
    var manualLanguage = false;
    try {
      manualCountry = Boolean(localStorage.getItem(manualCountryKey));
      manualLanguage = Boolean(localStorage.getItem(manualLanguageKey));
    } catch (error) {}
    var root = form.dataset.routesRoot || '/';
    var firstSegment = window.location.pathname.split('/')[1].toLowerCase();
    var explicitLocale = availableLocales.some(function (locale) {
      return firstSegment === locale || firstSegment.indexOf(locale + '-') === 0;
    });
    function preferredLocale(country) {
      if (manualLanguage || explicitLocale || !currentLocale || !availableLocales.length) return currentLocale;
      var target;
      var preferences = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      if (country === 'NO' || country === 'AE') {
        target = country === 'NO' ? 'nb' : 'ar';
        for (var index = 0; index < preferences.length; index += 1) {
          var browserLocale = String(preferences[index]).toLowerCase().split('-')[0];
          if (browserLocale === 'en') { target = 'en'; break; }
          if (country === 'NO' && /^(nb|no|nn)$/.test(browserLocale)) { target = 'nb'; break; }
          if (country === 'AE' && browserLocale === 'ar') { target = 'ar'; break; }
        }
      } else if (country === 'ZA' || country === 'NZ' || country === 'IE') {
        target = 'en';
      }
      return target && availableLocales.indexOf(target) !== -1 ? target : currentLocale;
    }
    function returnPath(localeChanged) {
      var path = window.location.pathname;
      if (localeChanged) {
        var rootPath = new URL(root, window.location.href).pathname;
        var prefix = rootPath.replace(/\/$/, '');
        if (prefix && (path === prefix || path.indexOf(prefix + '/') === 0)) path = path.slice(prefix.length) || '/';
        else if (firstSegment === currentLocale || firstSegment.indexOf(currentLocale + '-') === 0) {
          path = path.slice(firstSegment.length + 1) || '/';
        }
      }
      return path + window.location.search + window.location.hash;
    }
    function applyLocalization(code) {
      if (stopped || submitted) return;
      var locale = preferredLocale(code);
      var localeChanged = Boolean(locale && locale !== currentLocale);
      if (code === currentCountry && !localeChanged) {
        try { sessionStorage.removeItem(redirectKey); } catch (error) {}
        return;
      }
      try {
        var previous = JSON.parse(sessionStorage.getItem(redirectKey) || 'null');
        if (previous && previous.from === currentCountry && previous.to === code && previous.fromLocale === currentLocale && previous.toLocale === locale && Date.now() - previous.time < 10000) return;
        sessionStorage.setItem(redirectKey, JSON.stringify({from:currentCountry,to:code,fromLocale:currentLocale,toLocale:locale,time:Date.now()}));
      } catch (error) { return; }
      form.querySelector('input[name="country_code"]').value = code;
      var localeField = languageInput(form);
      if (localeField && locale) localeField.value = locale;
      form.querySelector('input[name="return_to"]').value = returnPath(localeChanged);
      submitted = true;
      form.submit();
    }
    if (manualCountry) { applyLocalization(currentCountry); return; }
    timeout = window.setTimeout(stop, 2500);
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry) + '&language[enabled]=false', {
      credentials: 'same-origin', signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    }).then(function (result) {
      if (stopped) return;
      var country = result.detected_values && result.detected_values.country;
      var code = country && country.handle;
      if (!code) { applyLocalization(currentCountry); return; }
      var supported = code === currentCountry || (result.suggestions || []).some(function (suggestion) {
        return suggestion.parts && suggestion.parts.country && suggestion.parts.country.handle === code;
      });
      if (supported) applyLocalization(code);
    }).catch(function () {}).finally(function () { window.clearTimeout(timeout); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["liitt-mobile-sticky"] && !Shopify.designMode) return;
  try {
    (function () {
  var bar = document.querySelector('.liitt-dock');
  var panel = document.querySelector('#choose-bundle');
  var main = panel && panel.querySelector('.pk-buy__cta');
  if (!bar || !panel || !main) return;
  var mobile = window.matchMedia('(max-width:767px)');
  var queued = false;
  var lastHeight = 0;
  var footer = document.querySelector('footer, .shopify-section-group-footer-group');
  var fields = {
    plan: bar.querySelector('[data-liitt-dock-plan]'),
    price: bar.querySelector('[data-liitt-dock-price]'),
    was: bar.querySelector('[data-liitt-dock-was]'),
    save: bar.querySelector('[data-liitt-dock-save]'),
    context: bar.querySelector('[data-liitt-dock-context]'),
    terms: bar.querySelector('[data-liitt-dock-renews]'),
    action: bar.querySelector('[data-liitt-dock-action]'),
    photo: bar.querySelector('[data-liitt-dock-photo]')
  };
  function text(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }
  function sync() {
    var opt = panel.querySelector('.pk-opt.is-selected');
    var name = opt && opt.querySelector('.pk-opt__name');
    var price = opt && opt.querySelector('.pk-opt__now');
    if (!name || !price) return false;
    var subscription = Boolean(opt.getAttribute('data-shopify-plan'));
    var photo = opt.querySelector('.liitt-serving-photo');
    if (photo && fields.photo.getAttribute('src') !== photo.getAttribute('src')) fields.photo.src = photo.getAttribute('src');
    text(fields.plan, name.textContent.trim());
    text(fields.price, price.textContent.trim());
    text(fields.action, bar.dataset.buyLabel);
    fields.price.classList.toggle('is-long-price', price.textContent.trim().length > 13);
    fields.was.hidden = true;
    fields.save.hidden = true;
    text(fields.context, '');
    var terms = opt.getAttribute('data-renews') || '';
    var cancellation = opt.getAttribute('data-sticky-terms') || '';
    if (subscription && cancellation && terms.toLowerCase().indexOf(cancellation.toLowerCase()) === -1) terms += ' · ' + cancellation;
    text(fields.terms, terms);
    return true;
  }
  function overlayOpen() {
    return Boolean(document.querySelector('cart-drawer.active, header-drawer details[open], dialog[open]')) ||
      Array.from(document.querySelectorAll('[aria-modal="true"]')).some(function (node) {
        return node.getClientRects().length && window.getComputedStyle(node).visibility !== 'hidden';
      });
  }
  function update() {
    queued = false;
    bar.classList.add('is-compact');
    var active = document.activeElement;
    var editing = active && (active.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="range"])') || active.isContentEditable);
    var passed = panel.getBoundingClientRect().bottom <= -24;
    var footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
    var ready = sync();
    var show = mobile.matches && ready && passed && !editing && !footerVisible && !overlayOpen() &&
      !main.hasAttribute('data-liitt-checkout-loading');
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
    document.body.classList.toggle('sticky-cta-visible', show);
  }
  function schedule() {
    if (!queued) { queued = true; window.requestAnimationFrame(update); }
  }
  new IntersectionObserver(schedule, {threshold:[0,1]}).observe(panel);
  if (footer) new IntersectionObserver(schedule).observe(footer);
  new MutationObserver(schedule).observe(panel, {
    subtree:true, childList:true, characterData:true, attributes:true,
    attributeFilter:['class','data-shopify-plan','data-renews','data-liitt-checkout-loading']
  });
  document.querySelectorAll('cart-drawer, header-drawer details, dialog').forEach(function (node) {
    new MutationObserver(schedule).observe(node, {attributes:true, attributeFilter:['class','open','aria-hidden']});
  });
  new ResizeObserver(function () {
    var height = Math.ceil(bar.getBoundingClientRect().height);
    if (height && height !== lastHeight) {
      lastHeight = height;
      document.documentElement.style.setProperty('--liitt-dock-height', height + 'px');
      document.documentElement.style.setProperty('--liitt-dock-reserved-height', height + 'px');
    }
  }).observe(bar);
  ['scroll','resize','pageshow'].forEach(function (event) { window.addEventListener(event, schedule, {passive:true}); });
  ['change','click','focusin','focusout','ff:promo-prices-updated','ff:bundle-change'].forEach(function (event) {
    document.addEventListener(event, schedule);
  });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
  mobile.addEventListener('change', schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["liitt-reviews-polish"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.querySelector('.liitt-reviews-polished')) return;
    var enhanced = new WeakSet();
    function enhance(modal) {
      if (enhanced.has(modal)) return;
      var close = modal.querySelector('.jdgm-write-review-modal__close-btn');
      if (!close) return;
      enhanced.add(modal);
      function syncClose() {
        if (getComputedStyle(modal).display === 'none') {
          if (modal.contains(document.activeElement)) {
            var trigger = document.querySelector('.liitt-reviews-polished .jm-action-buttons__button');
            if (trigger) trigger.focus({ preventScroll: true });
          }
          return;
        }
        if (close.getAttribute('aria-hidden') === 'true') close.removeAttribute('aria-hidden');
      }
      function activate(node) {
        Array.from(node.parentElement.children).forEach(function (sibling) {
          if (sibling === node) sibling.setAttribute('data-liitt-current', '');
          else sibling.removeAttribute('data-liitt-current');
        });
        modal.setAttribute('data-liitt-flow-ready', '');
      }
      var section = modal.querySelector('.jdgm-write-review-modal__sections > .current-section');
      var page = modal.querySelector('.jdgm-write-review-modal__slider-container > .current-page');
      if (section) activate(section);
      if (page) activate(page);
      var state = new MutationObserver(function (records) {
        records.forEach(function (record) {
          if (record.attributeName !== 'class') return;
          var node = record.target;
          var previous = (record.oldValue || '').split(/\s+/);
          if (node.matches('.jdgm-write-review-modal__section.current-section') && !previous.includes('current-section')) activate(node);
          if (node.matches('.jdgm-write-review-modal__slider-container > .jdgm-write-review-modal__page.current-page') && !previous.includes('current-page')) activate(node);
        });
        syncClose();
      });
      state.observe(modal, { subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
      modal.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || getComputedStyle(modal).display === 'none') return;
        event.preventDefault();
        event.stopPropagation();
        close.click();
      });
      syncClose();
    }
    document.querySelectorAll('.jdgm-write-review-modal').forEach(enhance);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.matches('.jdgm-write-review-modal')) enhance(node);
        });
      });
    }).observe(document.body, { childList: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
